<template>
    <button type="button" class="custom-radio" :disabled="disabled || readOnly" @click.prevent="handleClick">
        <span
            class="d-flex custom-control-indicator align-items-center justify-content-center"
            :class="indicatorClasses"
            :style="indicatorStyle">
            <span
                v-if="isTextIcon"
                class="custom-radio-text"
                :class="[iconToneClass, readOnly && 'read-only-font']"
                :style="readOnly && value === realValue && { color }">
                {{ icon }}
            </span>
            <component
                :is="diaryIcon"
                v-else
                :class="iconToneClass"
                :style="diaryIconStyle"
                :size="iconSize"/>
        </span>
    </button>
</template>

<script>
import CheckIcon from '@/common/components/svg-icons/CheckIcon.vue';
import getSvgIconFromClass from '@/common/components/svg-icons/helpers/getSvgIconFromClass';

export default {
    name: 'CustomDiaryIconButton',
    props: {
        value: Number,
        realValue: Number,
        disabled: Boolean,
        readOnly: Boolean,
        compact: Boolean,
        icon: String,
        color: String
    },
    computed: {
        isSelected() {
            return this.value === this.realValue;
        },
        isTextIcon() {
            return this.icon && this.icon.length <= 2;
        },
        iconSize() {
            return this.readOnly ? 20 : 18;
        },
        indicatorClasses() {
            return [
                !this.readOnly && !this.disabled && 'e3-pointer',
                this.compact && 'read-only-indicator',
                !this.readOnly && this.disabled && 'e3-indicator-disabled'
            ];
        },
        diaryIcon() {
            return this.icon ? getSvgIconFromClass(this.icon) : CheckIcon;
        },
        iconToneClass() {
            if (!this.isSelected) {
                return 'dark-gray';
            }
            if (!this.readOnly) {
                return 'text-white';
            }
            return null;
        },
        diaryIconStyle() {
            if (this.isSelected && this.readOnly && this.color) {
                return {color: this.color};
            }
            return null;
        },
        indicatorStyle() {
            if (this.readOnly) {
                return {};
            }
            return { backgroundColor: this.isSelected && this.color ? this.color : '#dfdfdf' };
        }
    },
    methods: {
        handleClick() {
            this.$emit('input', this.isSelected ? null : this.realValue);
        }
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.dark-gray {
    color: $separator;
}

.custom-radio-text {
    font-size: 15px;
    font-weight: bold;
}

.read-only-font {
    font-size: 17px;
}

.custom-radio {
    margin-bottom: 0;
    position: relative;
    display: block;
    padding: 0;
    border: none;
    background: none;
    appearance: none;

    .custom-control-indicator {
        display: block;
        position: relative;
        width: 28px;
        height: 28px;
        margin-left: auto;
        margin-right: auto;
        border-radius: 50%;
        transition: all 0.1s ease-in;

        &.read-only-indicator {
            width: auto;
            margin: 0;
        }

        &.e3-indicator-disabled {
            opacity: 0.5;
            cursor: default;
        }
    }
}
</style>
